import React, { useEffect } from 'react'
import { HitApi } from '../../../Api/ApiHit';
import { searchChild } from '../../../constant/Constant';
import AddChild from './AddChild';
import { setApiJson } from '../../../redux/Actions/ApiAction';
import { useDispatch, useSelector } from 'react-redux';

function EditChildService() {

    const ApiReducer = useSelector((state) => state.ApiReducer);
    const url = window.location.pathname;
    const UrlId = url.split('/')[2];
    const dispatch = useDispatch()

    console.log("UrlId", UrlId);

    useEffect(() => {
        if (UrlId) {
            getdata()
        }
    }, [])
    const getdata = () => {
        var json = {
            page: 1,
            limit: 1,
            search: {
                _id: UrlId
            }
        }
        HitApi(json, searchChild).then((res) => {
            if (res?.statusCode === 200) {
                dispatch(setApiJson(res?.data?.docs?.[0]))
            }
        })
    }
    return (
        <div>
            <AddChild editMode={true} />
        </div>
    )
}

export default EditChildService

